<template>
	<transition name="gc-modal__transition">
		<div class="gc-modal__wrapper" v-if="condition">
			<div class="modal-backdrop" @click="$emit('cancel')"></div>
			<div class="gc-modal-inner centered">
				<div class="gc-modal__header">
					<slot name="header">
						<h4 class="gc-modal__message--title">
							<slot name="messageTitle">Are you sure?</slot>
						</h4>
						<a @click="$emit('cancel')" class="gc-modal__close">×</a>
					</slot>
				</div>
				<div class="gc-modal__body">
					<slot name="body">
						<p class="gc-modal__message--body">
							<slot name="messageMain"></slot>
						</p>
						<p class="gc-modal__message--body gc-modal__message--body--alert">
							<slot name="messageInfo"></slot>
						</p>
					</slot>
				</div>
				<div class="gc-modal__footer">
					<slot name="footer">
						<a class="gc-modal__cancel" @click="$emit('cancel')">
							<slot name="cancelText">Cancel</slot>
						</a>
						<a class="btn btnRed" @click="$emit('ok')">
							<slot name="confirmText">OK</slot>
						</a>
					</slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'confirmmodal',
		props: ['condition'],
		methods: {
			escapeKeyHandler ({ which, keyCode }) {
				const key = which || keyCode
				if (key === 27) { // Esc
					if (this.condition) this.$emit('cancel')
				} else if (key === 13) {
					if (this.condition) this.$emit('ok')
				}
			}
		},
		mounted () {
			window.addEventListener('keyup', this.escapeKeyHandler)
		},
		destroyed () {
			window.removeEventListener('keyup', this.escapeKeyHandler)
		}
	}
</script>
